import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { Store } from "redux"

import { GlobalState } from "../../store"
import OldUIContext from "../../olduicontext"
import Footer from "./components/Footer"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (
        element: HTMLElement | undefined | null,
        params: {
            aboutSnippet: string
            arePreviewFeaturesEnabled: boolean
            versionSnippet: string
        },
    ) => void
}

function init(
    store: Store<GlobalState>,
    oldUIContext: IOldUIContext,
): OldUIInit {
    const start = (
        element: HTMLElement | undefined | null,
        params: {
            aboutSnippet: string
            arePreviewFeaturesEnabled: boolean
            versionSnippet: string
        },
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <OldUIContext.Consumer>
                            {(): JSX.Element => (
                                <Footer
                                    snippetContent={params.aboutSnippet}
                                    versionSnippet={params.versionSnippet}
                                    arePreviewFeaturesEnabled={
                                        params.arePreviewFeaturesEnabled
                                    }
                                />
                            )}
                        </OldUIContext.Consumer>
                    </OldUIContext.Provider>
                </Provider>,
            )
        }
    }

    return {
        start,
    }
}

export default init
